import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { Helmet } from "react-helmet";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import VideoLabelOutlinedIcon from '@mui/icons-material/VideoLabelOutlined';
import RoomPreferencesOutlinedIcon from '@mui/icons-material/RoomPreferencesOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import DomainVerificationRoundedIcon from '@mui/icons-material/DomainVerificationRounded';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import packageJson from "../../../package.json";
import "./settings.scss"

const Settings = () => {

    const { logout, user, hasPermission } = useContext(AuthContext);

    return (
        <div className="settings">
            <Helmet>
                <title>Einstellungen</title>
            </Helmet>
            <div className="container">
                <div className="header">
                    <h1>Einstellungen</h1>
                    <span>Verwalte deine Konto und Systemeinstellungen</span>
                </div>
                <div className="layout">
                    <div className="group profile">
                        <div className="info">
                            <span className="badge">{user.username?.[0]}</span>
                            <div className="data">
                                <span className="user">
                                    <bold>{user.name} {user.surname}</bold>
                                </span>
                                <span className="email">
                                    <span>{user.email}</span>
                                </span>
                            </div>
                        </div>
                        <Link onClick={logout} className="logout">
                            <LogoutOutlinedIcon />
                        </Link>
                    </div>
                    {hasPermission("data", "read") &&
                        <div className="group">
                            <h4>Stammdaten</h4>
                            <div className="grid">
                                <Link to="/data/users">
                                    <PersonOutlineOutlinedIcon className="icon" />
                                    <div className="data">
                                        <span>Benutzer</span>
                                        <span className="small">Benutzer verwalten</span>
                                    </div>
                                    <ArrowForwardIosRoundedIcon className="arrow" />
                                </Link>
                                <Link to="/data/items">
                                    <LocalShippingOutlinedIcon className="icon" />
                                    <div className="data">
                                        <span>Fuhrpark</span>
                                        <span className="small">Fahrzeuge verwalten</span>
                                    </div>
                                    <ArrowForwardIosRoundedIcon className="arrow" />
                                </Link>
                                <Link to="/data/team">
                                    <PeopleOutlinedIcon className="icon" />
                                    <div className="data">
                                        <span>Team</span>
                                        <span className="small">Team verwalten</span>
                                    </div>
                                    <ArrowForwardIosRoundedIcon className="arrow" />
                                </Link>
                                <Link to="/data/tracker">
                                    <VideoLabelOutlinedIcon className="icon" />
                                    <div className="data">
                                        <span>Tracker</span>
                                        <span className="small">GPS Tracker & Positionen</span>
                                    </div>
                                    <ArrowForwardIosRoundedIcon className="arrow" />
                                </Link>
                            </div>
                        </div>
                    }
                    <div className="group">
                        <h4>Benutzer</h4>
                        <span className="description">Systemparameter auf einem Blick</span>
                        <div className="list">
                            <div className="item">
                                <ManageAccountsOutlinedIcon className="icon" />
                                <div className="data">
                                    <span>ERGO Mitarbeiter ID</span>
                                </div>
                                <span className="value">{user.employeeId}</span>
                            </div>
                            <div className="item">
                                <ApartmentOutlinedIcon className="icon" />
                                <div className="data">
                                    <span>ERGO Kunden ID</span>
                                </div>
                                <span className="value">{user.companyId}</span>
                            </div>
                            <div className="item">
                                <RoomPreferencesOutlinedIcon className="icon" />
                                <div className="data">
                                    <span>Startseite</span>
                                </div>
                                <span className="value">{user.landingPage}</span>
                            </div>
                            <div className="item">
                                <DomainVerificationRoundedIcon className="icon" />
                                <div className="data">
                                    <span>App Version</span>
                                </div>
                                <span className="value">{packageJson.version}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;